export const LABEL_MAP = {
  nameSei: 'お名前[姓]',
  nameMei: 'お名前[名]',
  kanaSei: 'フリガナ[セイ]',
  kanaMei: 'フリガナ[メイ]',
  gender: '性別',
  selectedYear: '生年月日[年]',
  selectedMonth: '生年月日[月]',
  selectedDay: '生年月日[日]',
  zipcode: '郵便番号',
  telephone: '電話番号',
  clientId: 'メールアドレス',
  clientSecret: 'ログインパスワード',
  email: 'メールアドレス',
  userId: 'User ID',
  repeatedEmail: '確認用メールアドレス',
  password: 'ご希望のログインパスワード',
  currentPassword: '現在のログインパスワード',
  repeatedPhone: '確認用携帯電話番号',
  repeatedPassword: '確認用ログインパスワード',
  repeatedNewPassword: '新しいログインパスワードの確認',
  contact: 'お問い合わせ内容',
  shopName: '会社名・店舗名',
  name: 'お名前',
  cardNo: 'カード番号',
  expire: '有効期限',
  securityCode: 'セキュリティコード',
  holderName: 'カード名義',
  newPasscode: '新しいパスコード',
  repeatedNewPasscode: '新しい支払用パスコード',
  currentPasscode: '支払い用パスコード',
  newEmail: '確認用メールアドレス',
  passcode: '支払用パスコード',
  shopId: '店舗コード',
  code: '確認コード',
  newPassword: '新しいログインパスワード',
  shopCode: '店舗コード',
  moneyNum: '金額',
  numberPoint: '利用するポイント',
  newNumberPoint: '1からの整数',
  tosLink: '利用規約をご確認の上、ご利用を開始してください。',
  tosCheck: 'このサービスをご利用になる場合、利用規約への同意が必要となります。',
  id: '登録ID',
  pass: '認証番号',
  passcodeDefault: '新しいパスコードの確認',
  passcodePincode: '現在のパスコード',
  keyword: 'キーワード',
  oneTimeToken: '',
  mobilephone: '携帯電話番号',
  opinion: 'ご意見・ご感想等がございましたらご記入ください（任意）',
  emailEntry: 'メールアドレス',
  memo: 'メモ',
};

export const MESSAGE_MAP = {
  alphaNum: 'は数字で入力してください。',
  isNumber: 'が0から9までの数字を入力してください。',
  email: 'の形式が不正です。',
  minLength: 'は{{min}}文字で入力してください。',
  maxLength: 'は{{max}}文字以内で入力してください。',
  isSecurityCode: 'は3～4ケタの数字を入力してください。',
  isCardNo: 'は14～16桁の数字を入力してください。',
  required: 'を入力してください。',
  isNotEmpty: 'を入力してください。',
  emptyMemo: '{{memo}}を入力してください。',
  maxLengthMemo: '{{memo}}は{{max}}文字以内で入力してください。',
  isSelected: 'を選択してください。',
  between: ' の{{min}}文字以上{{max}}文字以下となります。',
  onlyKanaOrNull: 'はカタカナで入力してください。',
  sameAsPassword: 'はご希望のログインパスワードと一致しません。',
  sameAsNewPassword: 'は新しいログインパスワードと一致しません。',
  sameAsEmail: 'はメールアドレスと一致しません。',
  isPhoneNumberOrNull: 'は0から始まる10～11桁の数字で入力してください。',
  sameAsPasscode: 'は再入力した支払用パスコードと一致しません。',
  isPassCode: 'が間違っています。',
  isZipCodeOrNull: 'はハイフン無しの7桁の半角数字を入力してください。',
  // isAlphanumSpecialOrNull: 'は文字数で半角英数字および記号（￥を除く）を組み合わせ。',
  checkExpirationDate: 'の形式が不正です。',
  isAlphanumSpecialWithMinMaxLength:
    'が{{min}}文字以上{{max}}文字以内で半角英数字および記号(¥を除く)を全て組み合わせてご入力ください。',
  isAlphanumAndSpecialWithMinMaxLength:
    'は半角英数字を組み合わせ、{{min}}～{{max}}文字で設定してください。\nまた、半角記号（/ \\ ¥ を除く）を含めても構いません。',
  statusEvent: 'イベントは{{status}}のため、作業できません。',
  notSpace: 'にスペースを含まない文字で入力してください。',
  tosCheck: '',
  parentPaymentGuide: '合算支払い機能をご利用いただく場合、有効期限が早い残高から優先してお支払い致します。\n\n有効期限が同じ場合、取得した日時が早い残高を優先してお支払い致します。\n\n上記にご同意いただけない場合や、任意のイベントからお支払いをご希望される場合は、各イベント画面からお支払いをお願い致します。',
  invalidQrPoint: '該当するQRコードがありませんでした。',
  invalidQrPayment: '該当する店舗がありませんでした。',
  invalidQrSms: '正しいIDを入力してください。',
  invalidQrCpm: ' 正しいIDを入力してください。',
  isPasscodeSeq: '連番でのパスコードの登録はできません。',
  isPasscodeSameNum: '同番でのパスコードの登録はできません。',
  notFullSize: 'ログインできませんでした。',
  isRepeatedNewPasscode: '新しいパスコードと新しいパスコードの確認が一致しません。',
  sameAsSpecialPassword: 'の入力部分はログインパスワードと一致しません。',
  sameAsSpecialPhone : 'の入力部分は携帯電話番号と一致しません。',
  sameAsSpecialEmail: 'の入力部分はメールアドレスと一致しません。',
  isChangeUseLoginSms: 'イベントの設定が変更されました。お手数をおかけしますが、再度一から登録をやり直してください。',
  cameraNotFound: 'カメラ機能がOFFになっています。\nアプリの設定にてカメラ機能をONにしてください。',
  outOfLoginSession: 'セッションの有効期限が切れています。または、別の端末でログインされています。',
  paymentTimeout: '一定時間経過したため、再度店舗コードの読込みをしてください',
};

